import axios from 'axios';
import {
  API_UPDATE_PRESET, API_GET_PRESETS, API_GET_PRESET, API_GET_USER_PRESETS, API_CREATE_PRESET,
  API_GET_ORDER_PRESETS, API_GET_USER_ORDER_PRESETS, API_DELETE_PRESET, API_DELETE_ORDER_PRESET,
  API_GET_PRESETS_COUNT_USER, API_GET_PRESETS_COUNT, API_GET_PRESET_NAMES
} from '../../constants';
import { getErrorMessage } from "../../helpers/common.js";
import { wapiPolygon2DToGeoJson } from "../../helpers/wapihelpers.js";

export default {
  state: {
    presets: [],
    orderPresets: [],
    preset: null
  },
  mutations: {
    SET_PRESETS: (state, payload) => {
      state.presets = payload;
    },
    SET_ORDER_PRESETS: (state, payload) => {
      state.orderPresets = payload;
    },
    SET_PRESET: (state, payload) => {
      state.preset = payload;
      const exist = state.presets.find(x => x.id === payload.id);
      if (!exist) state.presets.push(payload);
    },
    UPDATE_PRESET(state, payload) {
      const index = state.presets.findIndex(item => item.id === payload);

      if (index !== -1) {
        state.presets[index] = payload;
      }
    },
    DELETE_PRESET(state, payload) {
      const index = state.presets.findIndex(item => item.id === payload);

      if (index !== -1) {
        state.presets.splice(index, 1);
      }
    },
    DELETE_ORDER_PRESET(state, payload) {
      const index = state.orderPresets.findIndex(item => item.id === payload);

      if (index !== -1) {
        state.orderPresets.splice(index, 1);
      }
    },
  },
  actions: {
    FETCH_PRESETS: async (context, payload) => {
      await context.dispatch('SET_LOADING', true);
      try {
        await context.dispatch('FETCH_CONTRACTS', payload.userId);        
        let presetsResponse = await axios.get(API_GET_PRESETS(payload.userId, payload.take, payload.skip));
        const presets = presetsResponse.data.result.data;
        presets.forEach(p => {
          p.area['id'] = p.id;
          p['geoJson'] = wapiPolygon2DToGeoJson(p, [1, 0]);
          p.geoJson['id'] = p.id;
        });
        context.commit('SET_PRESETS', presets);
        await context.dispatch('SET_LOADING', false);
        return presets;
      } catch (e) {
        await context.dispatch('SET_LOADING', false);
        context.commit('PUSH_ERROR_MESSAGE', e.message);
      }
    },
    FETCH_ORDER_PRESETS: async (context, userId) => {
      let presetsResponse = await axios.get(`${API_GET_ORDER_PRESETS}/${userId}?take=9999&skip=0`);
      const presets = presetsResponse.data.result.data;
      presets.forEach(p => {
        p.area['id'] = p.id;
      });
      context.commit('SET_ORDER_PRESETS', presets);
    },
    FETCH_USER_PRESETS: async (context, payload) => {
      try {
        context.commit('SET_LOADING', true);
        let presetsResponse = await axios.get(API_GET_USER_PRESETS(payload.take, payload.skip));
        const contract = await context.dispatch('FETCH_CONTRACT_INFO');
        const coordinateOrder = contract.preset_settings.coordinate_order;
        const presets = presetsResponse.data.result.data;
        presets.forEach(p => {
          p.area['id'] = p.id;
          p['geoJson'] = wapiPolygon2DToGeoJson(p, coordinateOrder);
          p.geoJson['id'] = p.id;
        });
        context.commit('SET_PRESETS', presets);
        context.commit('SET_LOADING', false);
        return presets;
      } catch (e) {
        context.commit('SET_LOADING', false);
        context.commit('PUSH_ERROR_MESSAGE', e.message);
      }
    },
    FETCH_USER_ORDER_PRESETS: async (context) => {
      try {
        let presetsResponse = await axios.get(`${API_GET_USER_ORDER_PRESETS}?take=9999&skip=0`);
        const presets = presetsResponse.data.result.data;
        presets.forEach(p => {
          p.area['id'] = p.id;
        });
        context.commit('SET_ORDER_PRESETS', presets);
      } catch (e) {
        context.commit('PUSH_ERROR_MESSAGE', e.message);
      }
    },
    FETCH_PRESET: async (context, payload) => {
      try {
        const response = await axios.get(`${API_GET_PRESET}/${payload.user_id}/${payload.id}`);
        const preset = response.data.result;
        if (!context.getters.CONTRACTS.length) {
          await context.dispatch('FETCH_CONTRACTS', payload.user_id);
        }        
        preset.area['id'] = payload.id;
        preset['geoJson'] = wapiPolygon2DToGeoJson(preset, [1, 0]);
        context.commit('SET_PRESET', preset);
        return preset;
      } catch (e) {
        context.commit('PUSH_ERROR_MESSAGE', e.message);
      }
    },
    FETCH_PRESET_NAMES: async (context, payload) => {
      await context.dispatch('SET_LOADING', true);
      try {
        const response = await axios.get(API_GET_PRESET_NAMES(payload.userId, payload.take, payload.skip));
        const presets = response.data.result.data;
        return presets;
      } catch (e) {
        context.commit('PUSH_ERROR_MESSAGE', e.message);
      }
    },
    FETCH_PRESET_COUNT_USER: async (context, payload) => {
      try {
        let response = await axios.get(API_GET_PRESETS_COUNT_USER(payload.userId));
        const count = response.data.result;

        return count;
      } catch (e) {
        context.commit('PUSH_ERROR_MESSAGE', e.message);
      }
    },
    FETCH_PRESET_COUNT: async (context) => {
      try {
        let response = await axios.get(API_GET_PRESETS_COUNT());
        const count = response.data.result;

        return count;
      } catch (e) {
        context.commit('PUSH_ERROR_MESSAGE', e.message);
      }
    },
    CREATE_PRESET: async (context, payload) => {
      try {
        const response = await axios.post(API_CREATE_PRESET, payload);
        const preset = response.data.result.data[0];
        const contract = await context.dispatch('FETCH_CONTRACT_INFO');
        const coordinateOrder = contract.preset_settings.coordinate_order;
        preset.area['id'] = preset.id;
        preset['geoJson'] = wapiPolygon2DToGeoJson(preset, coordinateOrder);
        context.commit('SET_PRESET', preset);
        context.commit('PUSH_SUCCESS', 'Территория успешно создана');
        return response.data.result;
      } catch (e) {
        const errMsg = e ?.response ?.data ?.message || e.message;
        context.commit('PUSH_ERROR_MESSAGE', errMsg);
      }
    },
    UPDATE_PRESET: async (context, payload) => {
      try {
        await axios.put(API_UPDATE_PRESET, payload);
        context.commit('UPDATE_PRESET', payload);
        context.commit('PUSH_SUCCESS', 'Территория успешно изменено');
        return true;
      } catch (err) {
        context.commit('PUSH_ERROR_MESSAGE', getErrorMessage(err));
        return false;
      }
    },
    DELETE_PRESET: async (context, payload) => {
      try {
        await axios.delete(`${API_DELETE_PRESET}/${payload.user_id}/${payload.id}`);
        context.commit('DELETE_PRESET', payload.id);
        context.commit('PUSH_SUCCESS', 'Территория успешно удалена');
        return true;
      } catch (err) {
        context.commit('PUSH_ERROR_MESSAGE', getErrorMessage(err));
        return false;
      }
    },
    DELETE_ORDER_PRESET: async (context, payload) => {
      try {
        await axios.delete(`${API_DELETE_ORDER_PRESET}/${payload.user_id}/${payload.id}`);
        context.commit('DELETE_ORDER_PRESET', payload.id);
        context.commit('PUSH_SUCCESS', 'Заказ территории успешно удален');
        return true;
      } catch (err) {
        context.commit('PUSH_ERROR_MESSAGE', getErrorMessage(err));
        return false;
      }
    },
  },
  getters: {
    PRESETS: state => {
      return state.presets;
    },
    ORDER_PRESETS: state => {
      return state.orderPresets;
    },
    PRESET_BY_ID(state) {
      return (presetId) => {
        return state.presets.find(p => p.id === presetId)
      }
    },
    PRESET(state) {
      return state.preset;
    }
  }
}